import { OrderType } from '../data/models/orders/orderType';

export const getOrderTypeLabel = (orderType: OrderType): string => {
  switch (orderType) {
    case OrderType.DineIn:
      return 'orders.type.dine-in';
    case OrderType.TakeAway:
      return 'orders.type.takeaway';
    case OrderType.Delivery:
      return 'orders.type.delivery';
    default:
      return orderType;
  }
};
